module.exports = __webpack_public_path__ + "img/ring_y_c_0_1@2x.2a9278a5.png";